"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var oUtils = _interopRequireWildcard(require("@financial-times/o-utils"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class Scroll {
  /**
   * Class constructor
   * @param {HTMLElement} [headerEl] - The component element in the DOM
   */
  constructor(headerEl) {
    this.headerEl = headerEl;
    this.container = headerEl.querySelector('[data-o-header-services-nav]');

    if (!this.container) {
      return;
    }

    this.list = this.container.querySelector('[data-o-header-services-nav-list]');
    this.buttons = Array.from(this.container.getElementsByTagName('button'), button => {
      button.addEventListener('click', this.scroll.bind(this));
      return button;
    });
    this.width = {};
    this.list.addEventListener('scroll', oUtils.debounce(this.toggleScrollButtons.bind(this), 100));
    window.addEventListener('resize', oUtils.debounce(this.toggleScrollButtons.bind(this), 500));
    this.render();
  }
  /**
   * Scroll functionality rendering
   */


  render() {
    this.showCurrentSelection();
    this.toggleScrollButtons();
  }
  /**
   * Hide/show scroll buttons
   */


  toggleScrollButtons() {
    this._getWidths();

    this.buttons.forEach(button => {
      if (button.className.match('left')) {
        button.disabled = this.list.scrollLeft === 0;
      } else {
        var remaining = this.width.list > this.width.container ? this._remaining() : 0;
        button.disabled = remaining <= 1;
      }
    });
  }
  /**
   * Scrolling functionality
   */


  scroll(e) {
    var distance = 100;

    if (e.currentTarget.className.match('left')) {
      distance = (this.list.scrollLeft > distance ? distance : this.list.scrollLeft) * -1;
    } else {
      var remaining = this._remaining();

      distance = remaining > distance ? distance : remaining;
    }

    this.list.scrollLeft = this.list.scrollLeft + distance;
    this.toggleScrollButtons();
  }

  _remaining() {
    return this.width.list - this.width.container - this.list.scrollLeft;
  }

  _getWidths() {
    this.width.list = this.list.scrollWidth;
    this.width.container = this.list.clientWidth;
  }
  /**
   * Scroll secondary nav to 'current selection'
   */


  showCurrentSelection() {
    this._getWidths();

    var currentSelection = this.list.querySelector('[aria-current]');

    if (!currentSelection) {
      return;
    }

    var currentSelectionEnd = currentSelection.getBoundingClientRect().right; //if the current selection is wider than the end of the list

    if (currentSelectionEnd > this.width.container) {
      // check by how much
      var diff = currentSelectionEnd - this.width.container; // if the difference is greater than half of the list, scroll to the end of the current selection.

      diff = diff > this.width.container / 2 ? currentSelectionEnd : this.width.container / 2;
      this.list.scrollTo({
        left: diff,
        top: 0,
        behaviour: 'smooth'
      });
    }
  }

}

var _default = Scroll;
exports.default = _default;
module.exports = exports.default;